import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  class: "text-white-500",
  value: null
}, "Choose wallet", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      required: "",
      id: "wallet",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenWallet) = $event))
    }, [
      _hoisted_2,
      _createElementVNode("option", {
        value: _ctx.WalletName.Phantom
      }, "Phantom", 8, _hoisted_3),
      _createElementVNode("option", {
        value: _ctx.WalletName.Sollet
      }, "Sollet", 8, _hoisted_4),
      _createElementVNode("option", {
        value: _ctx.WalletName.SolletExtension
      }, "Sollet Extension", 8, _hoisted_5),
      _createElementVNode("option", {
        value: _ctx.WalletName.Solflare
      }, "Solflare", 8, _hoisted_6),
      _createElementVNode("option", {
        value: _ctx.WalletName.SolflareWeb
      }, "Solflare Web", 8, _hoisted_7)
    ], 512), [
      [_vModelSelect, _ctx.chosenWallet]
    ])
  ]))
}